import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import type { PetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type AddressPlaceholderExperiment = PetitionDetailsPageUserData['experiments']['signFormAddressPlaceholderExperiment'];

type AddressPlaceholderExperimentResult = Readonly<{
	experiment: AddressPlaceholderExperiment;
	petitionId: string;
	/** False for fallback and QA-override sessions — neither is ever exposed. */
	isRealAssignment: boolean;
	/**
	 * The resolved arm, for the address field to branch on.
	 *
	 * `control` and `fake_control` render identically — that's where `fake_control` collapses onto control
	 * visually while staying a distinct analysis arm, which is what makes it usable as an A/A check.
	 */
	variation: AddressPlaceholderExperiment['variation'];
}>;

export function useAddressPlaceholderExperiment(): AddressPlaceholderExperimentResult {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { experiments },
	} = usePetitionDetailsPageUserData();

	const experiment = experiments.signFormAddressPlaceholderExperiment;

	return {
		experiment,
		petitionId: `petition_${id}`,
		isRealAssignment: !experiment.fallback && !experiment.override,
		variation: experiment.variation,
	};
}
